async function isDisabledEnity(entityType = "events", entityID) {
    try {
        const response = await fetch(`/api/${entityType}/${entityID}/disabled`);

        if (response.status !== 200) return false;

        const { payload } = await response.json();

        return payload;
    } catch (error) {
        return true;
    }
}

export default isDisabledEnity;
